"use strict";
/// <reference path="irep.js"/>

IREP.promoter = (function () {
    var init = (function () {
        
        //$('#promoter').popup('show');
        $(".printSummary .passed").html('<img src="../content/images/promoter/print-icon.png" alt="" />');

        
        
        $(".printSummary .activity .passed").closest(".activity").each(function (index) {
            
            $(this).find("a").attr('href', $(this).find("a").attr('href').replace('quiz', 'print')).attr("target", "_blank");

            
        });



        $('#submit').on('click', function () {

            if ($("#ispromoter").hasClass("checked") == true) {

                if ($.trim($("#agencyName").val()) != "" && $.trim($("#brandName").val()) != "" && $.trim($("#stores").val()) != "") {
                    postPromoterInfo(1);

                }
                else {
                    if ($.trim($("#agencyName").val()) == "") {
                        $("#agencyName ~ span:first").show();

                    }
                    else { $("#agencyName ~ span:first").hide(); }

                    if ($.trim($("#brandName").val()) == "") {
                        $("#brandName ~ span:first").show();
                    }

                    else { $("#brandName ~ span:first").hide(); }
                    if ($.trim($("#stores").val()) == "") {
                        $("#stores ~ span:first").show();
                    }
                    else { $("#stores ~ span:first").hide(); }

                }
            }
            else { postPromoterInfo(0); }
            
        });
      
        
       


       
        $("#ispromoter").click(function () {
            $('#ifPromoter').slideDown();
            $('.submit').show();
            $(this).addClass("checked");
            $("#isNotPromoter").removeClass("checked");
        })
        $("#isNotPromoter").click(function () {
            $('#ifPromoter').slideUp();
            $(this).addClass("checked");
            $('.submit').show();
            $("#ispromoter").removeClass("checked");

        })
        var a = $("#trainings1 .training").length;
        var b = $("#trainings2 .training").length;
        var c = $("#printSummary .training").length;

       

        $("#trainings1 .rightArrow").click(function () {
           
           
            if (a <= 5) {
                
                

            } else {

                if ($("#trainings1 .traininglist").is(':animated')) {
                    // do nothing
                } else {
                    TweenMax.to("#trainings1 .traininglist", .2, { left: "+=-1060px" });
                } 


            }

            
        });
        $("#trainings2 .rightArrow").click(function () {
           

            if (b <= 5) {
                


            } else {
                if ($("#trainings2 .traininglist").is(':animated')) {
                    $("#trainings2 .leftArrow").hide();
                } else {

                    TweenMax.to("#trainings2 .traininglist", .2, { left: "+=-1060px" });
                }
            }
        });
        $("#printSummary .rightArrow").click(function () {
            

            if (c <= 5) {
                


            } else {
                if ($("#printSummary .traininglist").is(':animated')) {
                    // do nothing
                } else {


                    TweenMax.to("#printSummary .traininglist", .2, { left: "+=-1060px" });
                }
            }
        });


        $("#trainings1 .leftArrow").click(function () {

           

            if (a <= 5) {
                


            } else {
                if ($("#trainings1 .traininglist").is(':animated')) {
                    // do nothing
                } else {



                    TweenMax.to("#trainings1 .traininglist", .2, { left: "-=-1060px", });
                }

            }


        });

        $("#trainings2 .leftArrow").click(function () {

            
            if (b <= 5) {

                alert("")

            } else {
                if ($("#trainings2 .traininglist").is(':animated')) {
                    // do nothing
                } else {

                    TweenMax.to("#trainings2 .traininglist", .2, { left: "-=-1060px", });
                }


            }


        });

        $("#printSummary .leftArrow").click(function () {

            

            if (c >= 5) {

               
                
            } else {
                if ($("#printSummary .traininglist").is(':animated')) {
                    // do nothing
                } else {

                    TweenMax.to("#printSummary .traininglist", .2, { left: "-=-1060px", });
                }

                

            }


        });

        var thumbCount = 0;
        $("#trainings1 .traininglist .training").each(function (index) {
            thumbCount = thumbCount + 1;
           
        });
        if (thumbCount <= 5) {
            $("#trainings1 .rightArrow, #trainings1 .leftArrow").hide();
        }
        thumbCount = 0;
        $("#trainings2 .traininglist .training").each(function (index) {
            thumbCount = thumbCount + 1;
           
        });
        if (thumbCount <= 5) {
            $("#trainings2 .rightArrow, #trainings2 .leftArrow").hide();
        }
        thumbCount = 0;
        $(".printSummary .traininglist .training").each(function (index) {
            thumbCount = thumbCount + 1;
          
        });
        if (thumbCount <= 5) {
            $(".printSummary .rightArrow, .printSummary .leftArrow").hide();
        }


        //$("#last_button").click(function () {

        //    var a = parseInt($(".comment:first").css("top"));

        //    if (a == 0) {

        //        $(".comment:first").css("top", "0");

        //    } else {

        //        $(".comment").animate({ top: "+=210px" }, "fast");

        //    }

        //});

    });

    var postPromoterInfo = function (isPromoter) {
        var data = {
            promoterInfo: {
                IsPromoter: isPromoter,
                Agency: $.trim($("#agencyName").val()),
                BrandOrProduct: $.trim($("#brandName").val()),
                StoresVisiting: $.trim($("#stores").val())
            }
        };

        return IREP.callApi({ url: "promoter/insert", data: data, type: "POST" })
        .done(function (data) {
            $('#promoterPopup').popup('hide');
        });
    };

    $("#yesShip").click(function () {
        $('#shipAddress').slideDown();
        $('.submitAddress').show().css("margin-left", "0px");
        $(this).addClass("checked");
        $("#noShip").removeClass("checked");
    })
    $("#noShip").click(function () {
        $('#shipAddress').slideUp();
        $(this).addClass("checked");
        $('.submitAddress').show().css("margin-left", "0px");
        $("#yesShip").removeClass("checked");
    })
    $("#close").click(function () {
        $("#addressPopup").hide();
    })
    $('#submitAddress').on('click', function () {
        if ($("#yesShip").hasClass("checked") == true) {
            if ($.trim($("#firstName").val()) != "" && $.trim($("#lastName").val()) != "" && $.trim($("#address1").val()) != "" && $.trim($("#city").val()) != ""
                && $.trim($("#country").val()) != "" && $.trim($("#postalCode").val()) != "" && $.trim($("#phone").val()) != "") {
                UpdatePromoter(1);
            }
            else {
                if ($.trim($("#firstName").val()) == "")
                    $("#firstName ~ span:first").show();
                else $("#firstName ~ span:first").hide();
                if ($.trim($("#lastName").val()) == "")
                    $("#lastName ~ span:first").show();
                else $("#lastName ~ span:first").hide();
                if ($.trim($("#address1").val()) == "")
                    $("#address1 ~ span:first").show();
                else $("#address1 ~ span:first").hide();
                if ($.trim($("#city").val()) == "")
                    $("#city ~ span:first").show();
                else $("#city ~ span:first").hide();
                if ($.trim($("#country").val()) == "")
                    $("#country ~ span:first").show();
                else $("#country ~ span:first").hide();
                if ($.trim($("#postalCode").val()) == "")
                    $("#postalCode ~ span:first").show();
                else $("#postalCode ~ span:first").hide();
                if ($.trim($("#phone").val()) == "")
                    $("#phone ~ span:first").show();
                else $("#phone ~ span:first").hide();
            }
        }
        else if ($("#noShip").hasClass("checked") == true){
            UpdatePromoter(0);
            $("#decline").css("display", "none");
        }
    });

    var UpdatePromoter = function (optIn) {
        var data;
            data = {
                promoterInfo: {
                    OptInExpertKit: optIn,
                    FirstName: $.trim($("#firstName").val()),
                    LastName: $.trim($("#lastName").val()),
                    Address1: $.trim($("#address1").val()),
                    Address2: $.trim($("#address2").val()),
                    City: $.trim($("#city").val()),
                    Country: $.trim($("#country").val()),
                    PostalCode: $.trim($("#postalCode").val()),
                    Phone: $.trim($("#phone").val())
                }
            };
        return IREP.callApi({ url: "promoter/update", data: data, type: "POST" })
        .done(function (data) {
            if (optIn === 1)
                $("#successful").css("display", "block");
            else
                $("#decline").css("display", "block");
            $("#close").css("display", "block");
            $("#submitAddress").css("display", "none");
            $("#address").css("display", "none");
        });
    };

    return {
        init: init
    };
}());